// ESM-Huelle um lib/scripts/pos/netcomm/CLS_COutputStream.js (Phase 4, Welle 4b).
// Prototype-Stil bleibt vorerst.
//******************************************************************************
// COutputStream
//******************************************************************************
// Description:
//      Provides a method to create an output stream and send data to it.
// Parameters:
//      transport - Pointer to a transport object.
//******************************************************************************

// *** Constructor ***
function COutputStream (transport)
{
    /*privMan.enablePrivilege (privList);*/
    this.ok = true;
    
    this.stream = transport.openOutputStream (0, 0, 0);
    
    this.dataCue = new Array ();
    this.failureCount = 0;
}
// ***

// *** Class variables ***
COutputStream.prototype.stream = null;
// ***

// *** Class methods ***
//------------------------------------------------------------------------------
// Description:
//      Sends data to an output stream.
//
// data - The data to be sent.
//------------------------------------------------------------------------------
COutputStream.prototype.send = function (data)
{
    if (!data) return;
    if (!this.ok) return;
    
    /*privMan.enablePrivilege (privList);*/
    
    var sendData = data.length + "\n" + data;
    
    this.dataCue.push (sendData);

    this.runSendCue (this);
    //setTimeout (this.runSendCue, 1, this);
}

COutputStream.prototype.sendRaw = function (data)
{
    if (!data) return;
    if (!this.ok) return;
    
    /*privMan.enablePrivilege (privList);*/
    
    this.dataCue.push (data);

    this.runSendCue (this);
    //setTimeout (this.runSendCue, 1, this);
}

COutputStream.prototype.runSendCue = function (me)
{
    if (!me.ok) return;
    
    var data = "";

    try
    {
        while (me.dataCue.length > 0)
            data += me.dataCue.shift ();

        var sendData = data;
        
        while (sendData.length > 0)
        {
            me.stream.write (sendData.substr (0, 10000), sendData.substr (0, 10000).length);
            sendData = sendData.substr (10000, sendData.length - 10000);
        }
        
        me.failureCount = 0;
    }
    catch (e)
    {
        if (me.failureCount > 10)
        {
            log.add (2, "Error", "COutputStream::send: Could not write to stream.", e);
            me.ok = false;
        }
        else
        {
            me.failureCount++;
            setTimeout (me.runSendCue, me.failureCount, me);
        }
    }
}
// ***

//******************************************************************************
export { COutputStream };
